export default __webpack_public_path__ + "static/media/google-ads-logo.684763d4.png";